<template>
  <http-patch-button
    v-bind="$props"
    :value="patches"
    :href="`/api/metadata/subscriptions/${(value || {}).subscriptionId}`"
    v-on="$listeners"
    version="v2"
    @http4xx="onError"
  >
  </http-patch-button>
</template>

<i18n>
{
    "en": {
        "patchSubscriptionButton.errorMessage": "There was an error encountered while patching this subscription. If everything looks right please contact support so we can help you :)"
    }
}
</i18n>

<script>
import { toastError } from "@/components/Common/Toast.vue";
import HttpPatchButton from "@/components/Common/HttpPatchButton.vue";

export default {
  props: {
    ...HttpPatchButton.props,
    form: {
      type: String
    },
    value: {
      type: Object,
    },
    patches: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onError() {
      toastError(this.$t("patchSubscriptionButton.errorMessage"));
    },
  },
};
</script>